import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { audit } from "../app/schema";

export const GET_AUDITS = "GET_AUDITS";
export const GET_AUDITS_SUCCESS = "GET_AUDITS_SUCCESS";
export const GET_AUDITS_ERROR = "GET_AUDITS_ERROR";

export const GET_AUDIT = "GET_AUDIT";
export const GET_AUDIT_SUCCESS = "GET_AUDIT_SUCCESS";
export const GET_AUDIT_ERROR = "GET_AUDIT_ERROR";

// Requests
const getAuditsGet = (fetch, apiHost, accessToken, meta) =>
  fetch(
    `${apiHost}/v1/audits?limit=${meta.limit}&offset=${meta.currentaudit *
      meta.limit}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      method: "GET"
    }
  ).then(response => {
    return validateResponse(response, {});
  });

const getAuditGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/audits/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

// Actions
export function getAudits(meta) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_AUDITS, GET_AUDITS_SUCCESS, GET_AUDITS_ERROR],
    payload: {
      promise: getAuditsGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        meta
      )
        .then(data => {
          return normalize(data, { audits: arrayOf(audit) });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateAudit(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_AUDIT, GET_AUDIT_SUCCESS, GET_AUDIT_ERROR],
    payload: {
      promise: getAuditGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, audit);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/audits/actions.js